export default "__VITE_ASSET__C925Png___"